import * as React from "react";

import { cn } from "@/lib/utils";

type MetaLineProps = Omit<React.ComponentProps<"div">, "children"> & {
  /** Falsy parts are dropped; the rest are joined with " · ". */
  parts: React.ReactNode[];
};

/**
 * The muted run and record meta line: "Worked for 2m · Gemini 3.8 Flash",
 * "edited 3d ago · 4 drafts". Sentence case; 12px `fg-3`.
 */
function MetaLine({ parts, className, ...props }: MetaLineProps) {
  const shown = parts.filter(
    (p) => p !== null && p !== undefined && p !== false && p !== ""
  );
  if (!shown.length) return null;
  return (
    <div
      data-slot="meta-line"
      className={cn(
        "flex min-w-0 items-center gap-1 text-sm text-fg-3 tabular-nums",
        className
      )}
      {...props}
    >
      {shown.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 ? (
            <span className="text-fg-4" aria-hidden>
              ·
            </span>
          ) : null}
          <span className="min-w-0 truncate">{part}</span>
        </React.Fragment>
      ))}
    </div>
  );
}

export { MetaLine };
export type { MetaLineProps };
